export enum ChatTags {
  payment = 'app_payment_transactionid_',
  ewallet = 'app_ewallet_transactionid_',
  checkout = 'app_checkout_transactionid_',
  posorder = 'app_posorder_transactionid_',
  invenco = 'app_invenco_transactionid_',
  insurance = 'app_insurance_transactionid_',

  fuelorder = 'app_fuelorder_transactionid_',
  shopincar = 'app_shopincar_transactionid_',
  storeorder = 'app_storeorder_transactionid_',
  parking = 'app_parking_transactionid_',
  mesra = 'app_mesra_transactionid_',
}
